import { AbstractControl, Validators, ValidatorFn } from '@angular/forms'
import * as moment from 'moment'

const POSTAL_CODE_PATTERNS = {
  US: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
  USA: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
  CA: /^[ABCEFGHJKLMNPRSTVXY][0-9][ABCEFGHJKLMNPRSTVWXYZ][ -]?[0-9][ABCEFGHJKLMNPRSTVWXYZ][0-9]$/,
  CAN: /^[ABCEFGHJKLMNPRSTVXY][0-9][ABCEFGHJKLMNPRSTVWXYZ][ -]?[0-9][ABCEFGHJKLMNPRSTVWXYZ][0-9]$/,
  GB: /^([A-Z]{1,2})([0-9]{1,2})([A-Z]{0,1})\s?([0-9][A-Z]{2})$/,
  GBR: /^([A-Z]{1,2})([0-9]{1,2})([A-Z]{0,1})\s?([0-9][A-Z]{2})$/
}

type StringResolver = () => string
type CountryResolver = string | StringResolver
export class CustomValidators extends Validators {

  public static dob13 (control: AbstractControl): { [key: string]: any} {
    const val: Date = control.value
    if (val && moment().diff(val, 'years') < 13) {
      return {
        dob13: {
          value: control.value,
          message: 'You must be at least 13 years old.'
        }
      }
    }
    return null
  }

  public static noPastDates (control: AbstractControl): { [key: string]: any} {
    const val: Date = control.value
    if (moment(val).isBefore(moment(), 'day')) {
      return {
        noPastDates: {
          value: control.value,
          message: 'Pick today\'s date or a date in the future.'
        }
      }
    }
    return null
  }

  public static postalCodeValidator(country: CountryResolver): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any} => {
      const countryValue: string = (typeof country === 'function') ? country() : country
      const matcher = POSTAL_CODE_PATTERNS[countryValue]
      if (!matcher) return null
      if (matcher.test(control.value)) return null
      return {
        postalCodeValidator: {
          value: control.value,
          message: 'Invalid ' + (this.countryPostalCodeLabel(countryValue)),
          altMessage: `Enter a valid ${(this.countryPostalCodeLabel(countryValue))}`,
        }
      }
    }
  }

  public static countryPostalCodeLabel(country: string): string {
    switch (country) {
      case 'US':
      case 'USA':
        return 'US zip code'
      case 'CA':
      case 'CAN':
        return 'Canadian postal code'
      default:
        return 'postal code'
    }
  }
}
